import { Box, Typography } from "@mui/material";

export default function ZenellaPrivacyFrPage() {
  return (
    <Box>
      <h1>Politique de confidentialité de Zenela</h1>
      <p>
        Language: <a href="zenella-privacy-policy">English</a>
      </p>
      <h3>
        Qu'est-ce que la politique de confidentialité et que couvre-t-elle ?
      </h3>

      <p>
        Nous chez{" "}
        <b>
          <Typography component="span" color="primary">
            Zenella
          </Typography>
        </b>{" "}
        de <b>Podosoft</b>, vous encourageons à lire notre politique de
        confidentialité pour vous aider à utiliser nos produits de la manière
        qui vous convient. <br />
        Notre politique de confidentialité ("Politique de confidentialité") aide
        à expliquer nos pratiques en matière de données, y compris les
        informations que nous traitons pour fournir nos services. <br />
        Par exemple, notre politique de confidentialité parle des informations
        que nous recueillons et de la manière dont cela vous affecte. Il
        explique également les mesures que nous prenons pour protéger votre vie
        privée, comme la sécurisation de vos données personnelles et vous donner
        le contrôle sur les personnes avec lesquelles vous communiquez sur nos
        Services.
        <br />
        Cette politique de confidentialité s'applique à tous les services
        Zenela, sauf indication contraire.
        <br />
        Le respect de votre vie privée est la première chose pour laquelle nous
        voulons vous aider, même si nous vous en donnons l'entière
        responsabilité. Depuis que nous avons lancé Zenela, au début de 2023,
        nous avons construit le service en gardant à l'esprit un ensemble de
        principes de confidentialité. Dans notre contenu suivant, vous trouverez
        :{" "}
      </p>

      <ul>
        <li>
          Informations supplémentaires sur la manière dont nous traitons vos
          données
        </li>
        <li>
          Meilleure communication avec les personnes avec lesquelles vous êtes
          en contact
        </li>
        <li>Simplifier l'utilisation</li>
      </ul>
      <br />

      <Typography component="h6" variant="h6" color="primary">
        Informations que nous recueillons
      </Typography>
      <p>
        Zenala doit recevoir ou collecter certaines informations pour exploiter,
        fournir, améliorer, comprendre, personnaliser, prendre en charge et
        commercialiser nos Services, y compris lorsque vous installez, accédez
        ou utilisez nos Services.
        <br />
        Les types d'informations que nous recevons et collectons dépendent de la
        manière dont vous utilisez nos Services. Nous avons besoin de certaines
        informations pour fournir nos services et sans cela, nous ne serons pas
        en mesure de vous fournir nos services. Par exemple, vous devez fournir
        votre numéro de téléphone mobile/e-mail pour créer un compte afin
        d'utiliser nos Services.
        <br />
        Nos Services comportent des fonctionnalités optionnelles qui, si vous
        les utilisez, nous obligent à collecter des informations supplémentaires
        pour fournir ces fonctionnalités. Vous serez informé de cette collecte,
        le cas échéant. Si vous choisissez de ne pas fournir les informations
        nécessaires pour utiliser une fonctionnalité, vous ne pourrez pas
        utiliser la fonctionnalité. Par exemple, vous ne pouvez pas télécharger
        de fichiers si vous n'autorisez pas l'accès au stockage depuis votre
        appareil. Les autorisations peuvent être gérées via votre menu
        Paramètres sur les appareils Android.
      </p>

      <Typography component="h6" variant="h6" color="primary">
        Informations que vous fournissez
      </Typography>
      <p>
        <b>• Vos informations de compte.</b> Vous devez fournir votre numéro de
        téléphone portable/e-mail et des informations de base (y compris un nom
        de profil de votre choix) pour créer un compte Zenela. Si vous ne nous
        fournissez pas ces informations, vous ne pourrez pas créer de compte
        pour utiliser nos Services. Vous pouvez ajouter d'autres informations à
        votre compte, telles qu'une photo de profil et des informations "à
        propos".
      </p>

      <p>
        <b>• Assistance client et autres communications.</b> Lorsque vous nous
        contactez pour l'assistance client ou communiquez avec nous, vous pouvez
        nous fournir des informations relatives à votre utilisation de nos
        Services, y compris des copies de vos commentaires textuels, tout autre
        les informations que vous jugez utiles et comment vous contacter (par
        exemple, une adresse e-mail). Par exemple, vous pouvez nous envoyer un
        e-mail contenant des informations relatives aux performances de
        l'application ou à d'autres problèmes.
      </p>
      <p>
        <b>Rapports d'utilisateurs.</b> Tout comme vous pouvez signaler d'autres
        utilisateurs, d'autres utilisateurs ou des tiers peuvent également
        choisir de nous signaler vos interactions ; par exemple, pour signaler
        d'éventuelles violations de nos Conditions ou politiques. Lorsqu'un
        signalement est effectué, nous recueillons des informations à la fois
        sur l'utilisateur signalant et sur l'utilisateur signalé. Pour en savoir
        plus sur ce qui se passe lorsqu'un signalement d'utilisateur est
        effectué, veuillez consulter
      </p>

      <Typography component="h6" variant="h6" color="primary">
        Comment nous utilisons les informations
      </Typography>

      <p>
        Nous utilisons les informations dont nous disposons (sous réserve des
        choix que vous faites et de la loi applicable) pour exploiter, fournir,
        améliorer, comprendre, personnaliser, prendre en charge et développer
        nos Services. Voici comment : <br />
        <br />
        <b>Nos Services.</b> Nous utilisons les informations dont nous disposons
        pour exploiter et fournir nos Services, y compris la fourniture d'un
        support client ; améliorer, corriger et personnaliser nos Services ;
        Nous utilisons également les informations dont nous disposons pour
        comprendre comment les gens utilisent nos Services ; évaluer et
        améliorer nos Services ; rechercher, développer et tester de nouveaux
        services et fonctionnalités ; et mener des activités de dépannage. Nous
        utilisons également vos informations pour vous répondre lorsque vous
        nous contactez.
        <br />
        <br />
        <b>Sûreté, sécurité et intégrité.</b> La sûreté, la sécurité et
        l'intégrité font partie intégrante de nos Services. Nous utilisons les
        informations dont nous disposons pour vérifier les comptes et
        l'activité ; lutter contre les comportements préjudiciables ; protéger
        les utilisateurs contre les mauvaises expériences et le spam ; et
        promouvoir la sûreté, la sécurité et l'intégrité sur et hors de nos
        Services, par exemple en enquêtant sur les activités suspectes ou les
        violations de nos Conditions et politiques, et pour garantir que nos
        Services sont utilisés légalement.
      </p>

      <Typography component="h6" variant="h6" color="primary">
        Informations que vous et nous partageons
      </Typography>
      <p>
        <b>• Informations associées à votre compte.</b> Votre numéro de
        téléphone, le nom et la photo de votre profil, les informations "à
        propos" et les informations consultées pour la dernière fois sont
        disponibles pour toute personne utilisant nos services, bien que vous
        puissiez configurer vos paramètres de services pour gérer certains
        informations disponibles pour les autres utilisateurs, y compris les
        entreprises, avec lesquels vous communiquez. Plus important encore, vous
        êtes responsable de toute action que vous entreprenez sur notre
        plateforme, tout ce que nous faisons est de vous fournir un outil pour
        partager des moments mémorables avec les gens
      </p>

      <Typography component="h6" variant="h6" color="warning">
        Avertissements{" "}
      </Typography>

      <p>
        Si vous partagez des informations que nous jugeons inappropriées, nous
        avons le droit de les supprimer et/ou de supprimer le compte si elles
        ont été publiées. ci-dessous, vous pouvez trouver certains types
        d'informations que nous jugeons inappropriées : contenu à caractère
        sexuel ou de nudité, violence, terrorisme, harcèlement, fraude ou
        arnaque, blessure, discours de haine, fausses informations, etc.
      </p>

      <Typography component="h6" variant="h6" color="primary">
        Mises à jour de notre politique
      </Typography>
      <p>
        Nous pouvons modifier ou mettre à jour notre politique de
        confidentialité. Nous vous informerons des modifications apportées à
        cette politique de confidentialité principalement par notification via
        l'application, le cas échéant, et mettrons à jour la date de « dernière
        modification » en haut de cette politique de confidentialité. Veuillez
        consulter notre politique de confidentialité de temps à autre.
      </p>

      <p>dernière modification : 13 Dec 2024</p>
    </Box>
  );
}
